import { 
  CompanyDetails, 
  RepresentativesDetails, 
  CarrierUsers,
} from './components';

export const tabs = ({isDirectSupplier, isIndirectSupplier}) => {
  return [
    {
      label: `1.1 Βασικά Στοιχεία`,
      id: 0,
      Component: CompanyDetails,
    },
    {
      label: `1.2 Στοιχεία Ταυτότητας Εκπροσώπων`,
      id: 1,
      Component: RepresentativesDetails,
    },
    {
      label: `1.3 Διαχείριση Χρηστών`,
      id: 2,
      Component: CarrierUsers,
      hidden: !isDirectSupplier,
    },
  ].filter(item => !item?.hidden);
};
